import {
  IdXboxIntroFormId,
  IdXboxIntroSubFormsIdsOrder,
  IdXboxIntroSubFormsLocalizedStringIds,
} from "../constants/formConstants";
import {
  AaaGameInformationFormId,
  AaaGameInformationSubFormsIdsOrder,
  AaaGameInformationSubFormsLocalizedStringIds,
} from "../subForms/aaaGameInformation/AaaGameInformationPageConstants";
import {
  GameInformationFormId,
  GameInformationSubFormsIdsOrder,
  GameInformationSubFormsLocalizedStringIds,
} from "../subForms/idXboxGameInformation/GameInformationPageConstants";
import {
  PitchInformationFormId,
  PitchInformationSubFormsIdsOrder,
  PitchInformationSubFormsLocalizedStringIds,
} from "../subForms/pitchInformation/PitchInformationPageConstants";

/* Onboarding Hub Programs */
export enum Programs {
  Unset = "unset",
  Aaa = "aaa",
  IdXbox = "id-xbox",
  Pitch = "pitch",
}

/* Program required component props */
export type ProgramRequiredComponentProps = {
  program: Programs;
};

/* Dynamic Dashboard components */
export enum Forms {
  AaaGameInformation = "AaaGameInformation",
  IdXboxIntroduction = "IdXboxIntroduction",
  GameInformation = "GameInformation",
  PitchInformation = "PitchInformation",
}

/* Form ID -> SubForms IDs mapping */
export type FormConfiguration = {
  formId: string;
  subFormIds: string[];
};

export const FormsConfiguration: { [form: string]: FormConfiguration } = {
  [Forms.AaaGameInformation]: {
    formId: AaaGameInformationFormId,
    subFormIds: AaaGameInformationSubFormsIdsOrder,
  },
  [Forms.IdXboxIntroduction]: {
    formId: IdXboxIntroFormId,
    subFormIds: IdXboxIntroSubFormsIdsOrder,
  },
  [Forms.GameInformation]: {
    formId: GameInformationFormId,
    subFormIds: GameInformationSubFormsIdsOrder,
  },
  [Forms.PitchInformation]: {
    formId: PitchInformationFormId,
    subFormIds: PitchInformationSubFormsIdsOrder,
  },
};

/* Localized strings IDs mapping for Forms and SubForms titles */
export const FormLocalizedTitleStringKey = "formTitle";
export const FormLocalizedSubtitleStringKey = "formSubtitle";
export const FormsLocalizedStringsConfiguration: {
  [form: string]: { [subForm: string]: string };
} = {
  [Forms.AaaGameInformation]: AaaGameInformationSubFormsLocalizedStringIds,
  [Forms.IdXboxIntroduction]: IdXboxIntroSubFormsLocalizedStringIds,
  [Forms.GameInformation]: GameInformationSubFormsLocalizedStringIds,
  [Forms.PitchInformation]: PitchInformationSubFormsLocalizedStringIds,
};
